import { createFileRoute } from "@tanstack/react-router";
import SelectDatasetPage from "~/pages/SelectDatasetPage";
import { z } from "zod";

const selectDatasetSearchParams = z.object({
  datasets: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        slug: z.string(),
      }),
    )
    .optional()
    .default([]),
  redirectTo: z
    .string()
    .refine((v) => v.startsWith("/") && !v.startsWith("//"), {
      message: "redirectTo must be a relative path",
    })
    .optional(),
  preferred_dataset_id: z.string().uuid().optional(),
  oauth: z
    .object({
      client_id: z.string(),
      redirect_uri: z.string().url().optional(),
      response_type: z.literal("code"),
      scope: z.string().optional(),
      state: z.string().optional(),
      channel: z.enum(["chrome_extension"]).optional(),
      code_challenge: z.string().min(43).max(128).optional(),
      code_challenge_method: z.enum(["S256"]).optional(),
      resource: z.string().url().optional(),
    })
    .superRefine((value, ctx) => {
      if (value.channel !== "chrome_extension" && !value.redirect_uri) {
        ctx.addIssue({
          code: "custom",
          path: ["redirect_uri"],
          message: "redirect_uri is required",
        });
      }
      if (value.channel === "chrome_extension" && !value.code_challenge) {
        ctx.addIssue({
          code: "custom",
          path: ["code_challenge"],
          message: "code_challenge is required",
        });
      }
    })
    .optional(),
});

export const Route = createFileRoute("/_public/select-dataset")({
  validateSearch: selectDatasetSearchParams,
  component: SelectDatasetPage,
});
